'use strict';

import slick from 'slick-carousel';

export const carousel = (() => {

    /**
     * init
     */
    const init = () => {

        const character = $('.js-carousel-character').slick({
            variableWidth: true,
        });

        gallery();
    }

    const gallery = () => {
        if ($('.js-carousel-gallery').length > 0) {
            $('.js-carousel-gallery').each((index, element) => {
                const $this = $(element);
                $this.not('.slick-initialized').slick({
                    fade: false,
                    arrows: true,
                    dots: false,
                    autoplay: false,
                    speed: 400,
                    infinite: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    centerPadding: 0,
                    centerMode: true,
                    variableWidth: false,
                    prevArrow: '<div class="slick-arrow slick-arrow--prev js-hover"><div class="slick-arrow__inner"></div></div>',
                    nextArrow: '<div class="slick-arrow slick-arrow--next js-hover"><div class="slick-arrow__inner"></div></div>'
                });
                $('.js-gallery').each((i, el) => {
                    const $el = $(el);
                    $el.on('click', event => {
                        if($el.data('modal-id') == 'gallery-modal'){
                            $this.slick('slickGoTo', i, true);
                        }
                    });
                });
            });
        }
    }

    // public
    return {
        init: init
    };
})();